module.exports = __webpack_public_path__ + "img/lock.f07b438e.svg";